import React, { Component } from "react";
import ModalForm from './Modal';
import DataTable from './Table';
import Loader from '../../../container/Loader';
// import Pagination from 'react-js-pagination';
import Home from '../../../container/Home';
import api from "../../../services/mail";
import "../../../styles/usuarios.css";

export default class List extends Component {

    constructor(props) {
        super(props);
            this.state = {
                loading: true,
                email: [],
                url: `/vendaonline/padrao-email`,
                showStore: true,
                search: null,
                pageSize: 10,
                pageNumeber: 1
            };
        this.pageSizes = [10, 20, 30, 40, 50];
    }

    async getEmail() {
        
        const Authorization = 'dRc9HOHgfpJVBEvm5TpwJSqpJ'
        const response = await api.get(this.state.url, { headers: { Authorization } })
        this.setState({email: response, loading: false})
    }

    componentDidMount() {
        this.getEmail()
    }

    searchSpace = (event) => {
        let keyword = event.target.value;
        this.setState({ search: keyword })
    }

    render() {
        if (this.state.loading) return <Loader />;
        const {data} = this.state.email
        // eslint-disable-next-line        
        const items = (data || []).filter((data) => {
            if (this.state.search == null)
                return data
            else if (data.descricao.toLowerCase().includes(this.state.search.toLowerCase())) {
                return data
            }
        })

        return (
            <Home menu={true} client={true} html={
                <>
                    <div>
                        <div className="usuarios-header">
                            <h4>PADRÕES DE EMAIL</h4>
                                <ModalForm buttonLabel="NOVO" buttonId="novo" className="modal-lg" />
                        </div>
                    </div>
                    <div className="lista-usuarios-wrapper">
                        <div className="barra-filtro">
                            <div className="barra-filtro-right">
                                <div className="barra-pesquisa">
                                    <input type="text" className="form-control col-12" placeholder="Nome do padrão"
                                        onChange={(e) => this.searchSpace(e)} />
                                </div>
                            </div>
                        </div>
                        <div className="table-responsive">
                            <DataTable data={items} />                       
                        </div>
                    </div>
                </>
            } />
        )
    }
}
